import React, { useEffect, useState } from "react";
import "./AvailableSlot.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseIcon from "@mui/icons-material/Close";
import {
  getMentorSlotsForUser,
  isUserAndMentorSame,
} from "../../../ApiServices/ApiServices";
import { handleError } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import dayjs from "dayjs";

const AvailableSlot = ({
  isVisible,
  setIsVisible,
  id,
  selectedPriceIndex,
  mentorName,
  sessionType,
  profileImage,
}) => {
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(null);
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [slotDate, setSlotDate] = useState([]);
  const navigate = useNavigate();
  const email = getEmail();
  const name = localStorage.getItem("loggedInUser");
  const closePopup = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const getSlotsDetails = async () => {
      try {
        const response = await getMentorSlotsForUser(id);
        const backendSlots = response.data; // Slot data from backend

        // Generate the next 30 days
        const today = dayjs();
        const endDate = today.add(7, "day"); // 7 days from today
        const dates = [];
        let currentDate = today.add(1, "day"); // Start from tomorrow

        while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
          const dayName = currentDate.format("ddd").toUpperCase();
          // Find matching day in backendSlots
          const matchedSlot = backendSlots.find(
            (slot) => slot.day === dayName
          ) || {
            slots: 0,
            time: [],
          };
          dates.push({
            day: dayName,
            date: currentDate.format("DD MMM YYYY"),
            slots: matchedSlot.slots,
            time: matchedSlot.time,
          });
          currentDate = currentDate.add(1, "day"); // Move to the next day
        }
        setSlotDate(dates); // Update the state with merged data
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    };

    getSlotsDetails();
  }, [id]);

  const bookNow = async () => {
    try {
      if (selectedTimeIndex === null) {
        return handleError("Please selecte the time!");
      }
      if (email) {
        const response = await isUserAndMentorSame(id, email);
        if (response?.isMatch) {
          return handleError("You cannot book the session with yourself!");
        }
        if (response?.isMentor) {
          return handleError("You are logged in as a mentor. Only mentees can book sessions!");
        }
      }
      navigate("/preview-bookings", {
        state: {
          mentorId: id,
          selectedPriceIndex,
          slotDate,
          selectedDateIndex,
          selectedTimeIndex,
          userEmail: email,
          userName: name,
          mentorName: mentorName,
          sessionType,
          profileImage,
        },
      });
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const chooseTime = (index) => {
    setSelectedTimeIndex(index);
  };

  const chooseDate = (index) => {
    setSelectedDateIndex(index);
  };

  return (
    <>
      {isVisible && (
        <div className="book-slot-overlay">
          <div className="book-slot-popup flex-col">
            <div className="close-icon" onClick={closePopup}>
              <CloseIcon />{" "}
            </div>
            <div className="available-text">Available Dates</div>
            <div className="available-slots flex">
              {slotDate?.map((item, index) => {
                return (
                  <div
                    onClick={() => chooseDate(index)}
                    className={`available-dates flex-col ${
                      selectedDateIndex === index ? "is-date-selected" : ""
                    }`}
                    key={index}
                  >
                    <div className="day">{item?.day}</div>
                    <div className="date">
                      {dayjs(item?.date).format("DD MMM")}
                    </div>
                    <div className="slots">{item?.slots} slots</div>
                  </div>
                );
              })}
            </div>
            <div className="divider"></div>
            <div className="available-date flex">
              <div className="">Available Slots</div>
              {/* <div className="scroll-icon">
                {" "}
                <NavigateBeforeIcon />
                <NavigateNextIcon />{" "}
              </div> */}
            </div>
            {slotDate[selectedDateIndex]?.time.length === 0 ? (
              <div>Not Available!</div>
            ) : (
              <div className="available-slots flex">
                {slotDate[selectedDateIndex]?.time.map((item, index) => {
                  return (
                    <div
                      onClick={() => chooseTime(index)}
                      className={`available-dates flex-col ${
                        selectedTimeIndex === index ? "is-date-selected" : ""
                      }`}
                      key={index}
                    >
                      <div className="available-time">{item?.value}</div>
                    </div>
                  );
                })}
              </div>
            )}

            <div onClick={bookNow} className="primary-btn book-now">
              Book Now
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AvailableSlot;
